var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-tabs',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('b-tab',{attrs:{"title":"Сотрудники"}},[(_vm.activeTab === 0)?_c('Users'):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }